export default "__VITE_ASSET__Cm9H8NrN__"